// extracted by mini-css-extract-plugin
export default {"cell":"MapRefundTokenCell_cell__cTtwg","token":"MapRefundTokenCell_token__hQDXM","copyButton":"MapRefundTokenCell_copyButton__s3QF8","copyIcon":"MapRefundTokenCell_copyIcon__idU09"};